// TODO: TDW-SUNSET

// TODO Replace with the BobEnum-generated constants
export const INTERVIEW_TYPE_IN_PERSON = { id: 1, displayName: 'In-person' };
export const INTERVIEW_TYPE_PHONE = { id: 2, displayName: 'Over the phone' };
export const INTERVIEW_TYPE_ONLINE = { id: 4, displayName: 'Online' };

export const STUDY_TYPE_MULTI_DAY = {
  id: 3,
  displayName: 'Multi Day Study',
  displayNoun: 'multi day study',
};

export const STUDY_TYPE_UNMODERATED_TASK = {
  id: 4,
  displayName: 'Unmoderated Task',
  displayNoun: 'unmoderated task',
};
